import FileSaver from "file-saver";

const convertToBlob = async (data) => {
  if (data instanceof Blob) {
    return data;
  } else if (data instanceof Response) {
    return await data.blob();
  } else if (typeof data === "string") {
    return new Blob([data]);
  }
  return null;
};

export const saveFile = async (data, filename) => {
  const blob = await convertToBlob(data);
  if (!blob) {
    console.warn(`Unable to download ${filename} (file type not supported)`);
    return null;
  }
  FileSaver.saveAs(blob, filename);
};

export const openFile = async (data, filename) => {
  const blob = await convertToBlob(data);
  if (!blob) {
    console.warn(`Unable to open ${filename} (file type not supported)`);
    return null;
  }
  const fileURL = URL.createObjectURL(blob);
  window.open(fileURL);
};

export const getFileExtension = (fileName) => {
  const match = (fileName || "").trim().match(/(?:\.([^.]+))?$/);
  return match && match.length > 1 ? (match[1] || "").toLowerCase() : undefined;
};

export const stripFileExtension = (fileName) => {
  return (fileName || "").trim().replace(/(?:\.([^.]+))?$/, "");
};

export const getFileIcon = (fileExtension) => {
  switch (fileExtension) {
    case "doc":
    case "docx":
    case "odt":
      return "DOC";
    case "gif":
    case "jpg":
    case "jpeg":
    case "png":
    case "svg":
    case "tif":
    case "tiff":
    case "webp":
      return "IMG";
    case "pdf":
      return "PDF";
    case "ppt":
    case "pptx":
      return "PPT";
    case "xls":
    case "xlsx":
    case "csv":
      return "XLS";
    case "zip":
      return "ZIP";
    default:
      return null;
  }
};

export const imageExtensions = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "svg",
  "webp",
];

export const validPreviewExtensions = [
  ...imageExtensions,
  "pdf",
  "doc",
  "docx",
  "odt",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "txt",
  "csv",
  "htm",
  "html",
];

export const canPreviewFile = (file) =>
  !!file?.id &&
  validPreviewExtensions.includes(getFileExtension(file.name ?? file.fileName));
